<template>
    <div class="mb-5 mt-2">

        <div class="card card-body bg-light mb-3">
            <div class="row">
                <div class="col-md-8 mb-3 mb-md-0">
                    <div class="row mb-3">
                        <label for="formOptions" class="col-sm-3 col-form-label">Changes from last</label>
                        <div class="col-sm-5 mb-3 mb-md-0">
                            <select id="formOptions" @change="filterRates" class="form-select"
                                    v-model="changesFrom">
                                <option v-for="option in compareColums" :key="option.key"
                                        :value="option.key">{{ option.value }}
                                </option>
                            </select>
                        </div>
                        <div class="col-sm-4">
                            <select id="changesOnly" @change="filterRates" class="form-select"
                                    v-model.number="changesOnly">
                                <option value="0">Show all rates</option>
                                <option value="1">Changes Only</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <label for="lenderTypes" class="col-sm-3 col-form-label">Lender type</label>
                        <div class="col-sm-5 mb-3 mb-md-0">
                            <select id="lenderTypes" @change="filterRates" class="form-select"
                                    v-model="lenderType">
                                <option v-for="option in lenderTypes" :key="option.key"
                                        :value="option.key">
                                    {{ option.value }}
                                </option>
                            </select>
                        </div>
                        <div class="col-sm-4">
                            <select id="term" class="form-select" v-model="term">
                                <option value="">All Terms</option>
                                <option v-for="column in columns" :key="column.key"
                                        :value="column.key" v-if="column.key !== 'lender_name'">
                                    {{ column.label }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 border-start">
                    <div class="row mb-3">
                        <label for="propertyValue" class="col-5 col-form-label">Property value</label>
                        <div class="col-4 mb-3 mb-md-0">
                            <input type="number" class="form-control" id="propertyValue" placeholder="" v-model="propertyValue">
                        </div>
                        <div class="col-3">
                            <button class="btn btn-light border" type="button" @click="calculateValues"><i class="fa fa-arrow-right"></i></button>
                        </div>
                    </div>
                    <div class="row">
                        <label for="loanAmount" class="col-5 col-form-label">Loan amount</label>
                        <div class="col-4 mb-3 mb-md-0">
                            <input type="number" class="form-control" id="loanAmount" placeholder="" v-model="loanAmount">
                        </div>
                        <div class="col-3">
                            <button class="btn btn-light border" type="button" @click="clearValues"><i class="fa fa-close"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card p-0 overflow-y-scroll overflow-md-hidden">
            <table class="table m-0">
                <thead class="d-flex flex-column">
                <tr>
                    <th class="bg-light" v-for="column in columns" :key="column.key"
                        v-if="column.key === 'lender_name' || term === '' || term === column.key">
                        <div class="flex">
                            <span>{{ column.label }}</span><br>

                            <a class="" @click="sortTable(column.key,'desc')">
                                <i :class="currentSortDir === 'desc' && currentSort === column.key ? 'text-success': ''"
                                   class="fa fa-angle-up ml-1" style="font-size: smaller"></i>
                            </a>

                            <a class="" @click="sortTable(column.key,'asc')">
                                <i :class="currentSortDir === 'asc' && currentSort === column.key ? 'text-success': ''"
                                   class="fa fa-angle-down ml-1" style="font-size: smaller"></i>
                            </a>
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody v-if="isLoading" class="d-flex flex-column">
                <tr>
                    <td colspan="10" class="text-center">
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </td>
                </tr>
                </tbody>
                <tbody v-else class="d-flex flex-column">
                <tr :class="{'bg-light': index % 2 === 0, 'h-5': true}" v-for="(rate,index) in filtered"
                    :key="rate.id">
                    <td v-for="column in columns" :key="column.key"
                        v-if="column.key === 'lender_name' || term === '' || term === column.key">
                        <div class="rate" :class="calculateClass(rate, column.key)">
                            {{ rate[column.key] ?? '-' }}
                        </div>
                    </td>
                </tr>
                </tbody>
                <tfoot v-if="filtered.length > 0" class="d-flex flex-column">
                <tr>
                    <td v-for="column in columns" :key="column.key" class="bg-light dark"
                        v-if="column.key === 'lender_name' || term === '' || term === column.key">
                        <div class="rate">
                            {{ median[column.key] }}
                        </div>
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>

        <h5 v-if="filtered.length < 1" class="text-center">No Rates</h5>
    </div>
</template>

<script>
export default {
    name: "MortgageRates",

    data() {
        return {
            lenderType: -1,
            isLoading: false,
            rates: [],
            median: {},
            filtered: [],
            changesFrom: '1week',
            changesOnly: 0,
            term: '',
            propertyValue: 0,
            loanAmount: 0,

            lenderTypes: [
                {key: -1, value: 'All Lenders'},
                {key: 2, value: 'Major Banks'},
                {key: 1, value: 'Minor Banks'},
                {key: 0, value: 'Non Banks'},
            ],

            compareColums: [
                {key: '1day', value: 'One Day'},
                {key: '1week', value: 'One Week', selected: true},
                {key: '2week', value: 'Two Weeks'},
                {key: '4week', value: 'Four Weeks'},
                {key: '3month', value: 'Three Months'},
                {key: '6month', value: 'Six Months'},
            ],

            columns: [
                {key: 'lender_name', label: 'Mortgage Lender'},
                {key: 'rate_floating', label: 'Floating'},
                {key: 'rate_6month', label: '6 Mth'},
                {key: 'rate_1year', label: '1 Year'},
                {key: 'rate_18month', label: '18 Mth'},
                {key: 'rate_2year', label: '2 Year'},
                {key: 'rate_3year', label: '3 Year'},
                {key: 'rate_4year', label: '4 Year'},
                {key: 'rate_5year', label: '5 Year'},
                {key: 'rate_rc', label: 'RC'},
            ],
            currentSort: 'lender_name',
            currentSortDir: 'asc',
        };
    },

    mounted() {
        this.getRates(this.changesFrom)
    },

    methods: {
        filterRates() {
            this.filtered = this.rates;
            if(this.loanAmount > 0 && this.propertyValue > 0) {
                let lvr = (this.loanAmount / this.propertyValue * 100).toFixed(2);
                this.filtered = this.filtered.filter(rate => rate.min_lvr <= lvr || rate.max_lvr >= this.loanAmount);
            }
            if (this.loanAmount > 0) {
                this.filtered = this.filtered.filter(rate => rate.min_loan >= this.loanAmount);
            }
            if (this.lenderType > -1) {
                this.filtered = this.filtered.filter(rate => rate.lender_type === this.lenderType);
            }
            if (this.changesOnly > 0) {
                this.filtered = this.filtered.filter(rate => {
                    let hasChange = false;
                    for (let column of this.columns) {
                        if (column.key === 'lender_name') continue;
                        for (let compare of this.compareColums) {
                            let columnKey = `${column.key}_${compare.key}`;
                            if ((rate[columnKey] ?? false) && rate[columnKey] !== rate[column.key]) {
                                hasChange = true;
                                break;
                            }
                        }
                    }
                    return hasChange;
                });
            }
            this.calculateMedian();
        },

        getRates(changesFrom) {
            this.isLoading = true;

            axios({
                method: 'GET',
                url: `/mortgage/rates?changes_from=${changesFrom}`
            }).then(res => {
                this.rates = res.data
                this.filtered = res.data;
                // console.log(res.data);
            }).catch(err => {
                console.log({error: err})
            }).finally(() => {
                this.sortTable(this.currentSort, this.currentSortDir);
                this.isLoading = false;
            });
        },

        sortTable(s, dir) {
            if (s === this.currentSort) {
                this.currentSortDir = dir;
            }
            this.currentSort = s;
            this.filtered.sort((a, b) => {
                let sortA, sortB;
                if (this.currentSort === 'lender_name') {
                    sortA = a[this.currentSort];
                    sortB = b[this.currentSort];
                    let modifier = (this.currentSortDir === 'asc') ? 1 : -1;
                    if (sortA < sortB) return -1 * modifier;
                    if (sortA > sortB) return modifier;
                } else {
                    if (a[this.currentSort] === '-') a[this.currentSort] = null;
                    if (b[this.currentSort] === '-') b[this.currentSort] = null;
                    if (this.currentSortDir === 'asc') {
                        sortA = (a[this.currentSort] == null) ? Number.MAX_SAFE_INTEGER : parseFloat(a[this.currentSort]);
                        sortB = (b[this.currentSort] == null) ? Number.MAX_SAFE_INTEGER : parseFloat(b[this.currentSort]);
                        return sortA - sortB;
                    } else {
                        sortA = (a[this.currentSort] == null) ? Number.MIN_SAFE_INTEGER : parseFloat(a[this.currentSort]);
                        sortB = (b[this.currentSort] == null) ? Number.MIN_SAFE_INTEGER : parseFloat(b[this.currentSort]);
                        return sortB - sortA;
                    }
                }
            });
            this.calculateMedian();
        },

        calculateMedian() {
            let median = {};
            this.columns.forEach(column => {
                if (column.key === 'lender_name') {
                    median[column.key] = 'Median';
                } else {
                    let values = this.filtered
                        .map(rate => rate[column.key])
                        .filter(value => value !== undefined && value !== null)
                        .map(value => parseFloat(value))
                        .sort((a, b) => a - b);
                    let mid = Math.floor(values.length / 2);
                    median[column.key] = values.length % 2 !== 0 ? values[mid] : (values[mid - 1] + values[mid]) / 2;
                    if (isNaN(median[column.key])) {
                        median[column.key] = '-';
                    } else {
                        median[column.key] = median[column.key].toFixed(2);
                    }
                }
            });
            this.median = median;
        },

        calculateClass(rate, column) {
            let classes = [];
            classes.push(column);
            let columnKey = `${column}_${this.changesFrom}`;
            if (rate[columnKey] ?? false) {
                if (rate[columnKey] > rate[column]) {
                    classes.push('text-success');
                    classes.push('arrow-down');
                } else if (rate[columnKey] < rate[column]) {
                    classes.push('text-danger');
                    classes.push('arrow-up');
                }
            }
            return classes.join(' ');
        },

        clearValues() {
            this.propertyValue = 0;
            this.loanAmount = 0;
            this.filterRates();
        },

        calculateValues() {
            if (this.loanAmount > this.propertyValue) {
                this.propertyValue = 0;
            }
            this.filterRates();
        }
    },
}
</script>

<style scoped>
tr {
    display: flex;
    flex-direction: row;
}

th, td {
    font-size: 14px;
    font-weight: bold;
    width: 65px;
    flex-grow: 0;
}

td {
    color: grey;
}

@media (max-width: 768px) {
    tr td:first-child, tr th:first-child {
        width: 150px;
    }
}

tr td:first-child, tr th:first-child {
    width: auto;
    text-align: left;
    font-weight: 600;
    color: black;
    flex-grow: 1;
    position: sticky;
    left: 0;
    background: white;
    z-index: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card {
    border-radius: 3px !important;
}

@media (min-width: 768px) {
    .card {
        overflow: hidden !important;
    }
}

.rate {
    position: relative;
    padding-left: .5rem;
    padding-right: .5rem;
    text-align: right;
}

td:first-child .rate {
    text-align: left;
    padding-left: 0;
}

.arrow-up, .arrow-down {
    position: relative;
}

.arrow-up::before {
    content: '▲';
    font-size: 10px;
    position: absolute;
    left: 3px;
    top: 2px;
}

.arrow-down::before {
    content: '▼';
    font-size: 10px;
    position: absolute;
    left: 3px;
    top: 2px;
}
</style>
